import * as React from "react";
const ClothesCorporateFemale = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1080 1920"
	>
		<defs>
			<style>
				{
					".cls-copr-fem-1{fill:none;}.cls-copr-fem-2{fill:#20456e;}.cls-copr-fem-3{clip-path:url(#clip-path-copr-fem);}.cls-copr-fem-4{fill:#dbe0ec;}.cls-copr-fem-5{fill:#c6cee0;}.cls-copr-fem-6{fill:#82cec4;}.cls-copr-fem-7{fill:#282b2e;}"
				}
			</style>
			<clipPath id="clip-path-copr-fem">
				<path
					className="cls-copr-fem-1"
					d="M785.74,740.43c-2-24.61-20.51-112.83-22.56-133.34s-16.41-135.4-16.41-135.4-2.06-18.47-16.42-30.78S646.24,397.83,619,381.15c-4.65,40.76-56.91,39.25-56.91,39.25s-52.26,1.51-56.91-39.25c-27.2,16.68-97,47.45-111.31,59.76s-16.42,30.78-16.42,30.78-14.36,114.88-16.41,135.4-20.51,108.73-22.56,133.34-18.47,186.69-18.47,186.69,18.47,12.31,51.29,6.16c6.15-34.88,61.54-336.45,61.54-342.61s8.21,32.83,8.21,32.83a253.26,253.26,0,0,1,10.26,43.08c2,14.36,5.16,46.7,6.15,61.55,20.52,10.25,84.11,10.25,104.63,10.25s84.11,0,104.63-10.25c1-14.85,4.1-47.19,6.15-61.55a253.26,253.26,0,0,1,10.26-43.08s8.21-39,8.21-32.83,55.39,307.73,61.54,342.61c32.82,6.15,51.29-6.16,51.29-6.16S787.8,765.05,785.74,740.43Z"
				/>
			</clipPath>
		</defs>
		<title>{"habit corporate f"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="corporate_f" data-name="corporate f">
			<path
				className="cls-copr-fem-2"
				d="M713.94,879.94c-8.2-61.55-47.18-149.76-47.18-149.76l-104.63-2-104.63,2s-39,88.21-47.18,149.76,6.15,305.67,18.46,363.12c26.67,10.25,102.58,20.51,133.35,20.51s106.68-10.26,133.35-20.51C707.79,1185.61,722.15,941.48,713.94,879.94Z"
			/>
			<g className="cls-copr-fem-3">
				<path
					className="cls-copr-fem-4"
					d="M785.74,740.43c-2-24.61-20.51-112.83-22.56-133.34s-16.41-135.4-16.41-135.4-2.06-18.47-16.42-30.78S646.24,397.83,619,381.15c-4.65,40.76-56.91,39.25-56.91,39.25s-52.26,1.51-56.91-39.25c-27.2,16.68-97,47.45-111.31,59.76s-16.42,30.78-16.42,30.78-14.36,114.88-16.41,135.4-20.51,108.73-22.56,133.34-18.47,186.69-18.47,186.69,18.47,12.31,51.29,6.16c6.15-34.88,61.54-336.45,61.54-342.61s8.21,32.83,8.21,32.83a253.26,253.26,0,0,1,10.26,43.08c2,14.36,5.16,46.7,6.15,61.55,20.52,10.25,84.11,10.25,104.63,10.25s84.11,0,104.63-10.25c1-14.85,4.1-47.19,6.15-61.55a253.26,253.26,0,0,1,10.26-43.08s8.21-39,8.21-32.83,55.39,307.73,61.54,342.61c32.82,6.15,51.29-6.16,51.29-6.16S787.8,765.05,785.74,740.43Z"
				/>
				<path
					className="cls-copr-fem-5"
					d="M433,592.08s-4.22-11.66-2.17-24,2.05,20.51,22.57,36.92c10.26,8.21,24.62,12.31,20.51,16.42s-12.3,8.2-20.51,6.15c-12.59-3.15-14.36-6.15-16.41-12.31s-4-23.21-4-23.21"
				/>
				<path
					className="cls-copr-fem-5"
					d="M689.37,592.08s4.21-11.66,2.16-24-2,20.51-22.57,36.92c-10.25,8.21-24.61,12.31-20.51,16.42s12.31,8.2,20.51,6.15c12.59-3.15,14.36-6.15,16.42-12.31s4-23.21,4-23.21"
				/>
				<path
					className="cls-copr-fem-5"
					d="M595,611.19c-8.2-6.16-32.82-6.16-32.82-6.16s-24.62,0-32.82,6.16c-2.06,2,2.05,2,2.05,2H592.9S597,613.24,595,611.19Z"
				/>
				<path
					className="cls-copr-fem-6"
					d="M387.75,434.76s10.26-2.05,22.57,24.62S439,545.54,434.94,570.16s-8.21,69.75-8.21,69.75L393.91,964.05l-160-8.21,86.16-500.57Z"
				/>
				<path
					className="cls-copr-fem-6"
					d="M733.05,434.76s-10.26-2.05-22.57,24.62-28.72,86.16-24.62,110.78,8.21,69.75,8.21,69.75l32.82,324.14,160-8.21L800.75,455.27Z"
				/>
				<path
					className="cls-copr-fem-6"
					d="M617.52,369.11l-55.39,49.24-55.39-49.24s-14.36,10.26-14.36,14.36S496.48,404,515,428.6s47.18,24.62,47.18,24.62,28.72,0,47.18-24.62,22.57-41,22.57-45.13S617.52,369.11,617.52,369.11Z"
				/>
			</g>
			<path
				className="cls-copr-fem-7"
				d="M478,1710s-4.14,19.26-4.14,25.42-2.41,41.17-4.1,51.29c-2.05,12.31,1,42.8,4.1,55.39,2.05,8.2,18.47,12.31,24.62,14.36s16.41,2,20.52,0,10.25-4.11,12.31-8.21,6.15-22.57,6.15-22.57,4.1-12.3,0-28.72c0-4.1-2.05-82.06-2.05-82.06s-1.49-10.73-3.83-13.57c1.78,9.47,1.78,21.78,1.78,21.78L534,1754a362.82,362.82,0,0,1-.64,40.91c-6.16,8.21-49.24,4.11-49.24,4.11s-10.26.11-10.26-18.47c0-12,2.62-30.12,4.11-45.13A142.84,142.84,0,0,0,478,1710Z"
			/>
			<path
				className="cls-copr-fem-7"
				d="M641,1711c5.53,17.67,4.51,18.18,4.51,24.42s2.42,41.17,4.1,51.29c2,12.31-1,42.8-4.1,55.39-2,8.2-18.47,12.31-24.62,14.36s-16.41,2-20.51,0-10.26-4.11-12.31-8.21-6.16-22.57-6.16-22.57-4.1-12.3,0-28.72c0-4.1,2.05-82.06,2.05-82.06s.71-11.06,3-13.9c-1,10-1,22.11-1,22.11l-.64,30.89a362.82,362.82,0,0,0,.64,40.91c6.16,8.21,49.24,4.11,49.24,4.11s10.26.11,10.26-18.47c-1.51-11.55-2.61-30.12-4.1-45.13A153,153,0,0,1,641,1711Z"
			/>
		</g>
	</svg>
);
export default ClothesCorporateFemale;
